import React, { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import styles from "./style.module.scss";
import { MainContext } from "../context/MainContext";

import { useLoginFlow } from "../components/hooks/useLoginFlow";

import icon from "../assets/image/Frame.png";
import bold from "../assets/image/boldx.jpg";

import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

const API_URL = process.env.REACT_APP_API;

const LoginPage = () => {
  const navigate = useNavigate();
  const {
    setIsLoadUserId,
    setUndefinedUserId,
    setAction,
    setArchive,
    setMarkers,
    setUserLocation,
    setUser,
    setFetchFaults,
    setFetchPdf,
    setOrdersCurrent,
    setOrdersResolved,
  } = useContext(MainContext);

  const { message, start } = useLoginFlow({
    setUser,
    setUserLocation,
    setMarkers,
    setArchive,
    setFetchFaults,
    setOrdersCurrent,
    setOrdersResolved,
    setFetchPdf,
    navigate,
    setIsLoadUserId,
    setUndefinedUserId,
    setAction,
  });

  useEffect(() => {
    const auth = async () => {
      const hash = new URLSearchParams(window.location.hash.substring(1));

      const accessToken = hash.get("access_token");

      if (!accessToken) {
        navigate("/error");
        return;
      }

      try {
        const response = await axios.post(`${API_URL}/token`, {
          access_token: accessToken,
        });

        const data = response.data;

        if (!data.success) {
          navigate("/error");
          return;
        }

        setUser({
          data: data.sessionToken,
          id: data.sessionToken.id_tg,
          email: data.email,
          role: data.role,
        });

        start();
      } catch (error) {
        console.error(error);
        navigate("/error");
      }
    };
    
    auth();
  }, []);

  return (
    <div className={styles.load}>
      <img className={styles.load__logo_bold} src={bold} alt="Logo" />
      <div className={styles.load__logo_container}>
        <img className={styles.load__logo} src={icon} alt="Logo" />
        <div>
          <h2>Fire Safety</h2>
          <p>Center</p>
        </div>
      </div>
      <div className={styles.load__cpb}>
        <h3 className={styles.load__cpb__title}>CPBZero</h3>
      </div>
      <div className={styles.load__progress}>
        <Box sx={{ display: "flex", marginRight: "20px" }}>
          <CircularProgress color="basic" size={20} />
        </Box>
        {message && <p className={styles.load__message}>{message}</p>}
      </div>
    </div>
  );
};

export default LoginPage;
